"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.AssetSchema = __1.BaseSchema.extend({
    store: __1.StoreSchema.partial().required({ id: true }),
    entity: zod_1.z.nativeEnum(__1.EntityType),
    type: zod_1.z.nativeEnum(__1.AssetType),
    url: zod_1.z.string().url().optional(),
    size: zod_1.z.number().int().positive().optional(),
    width: zod_1.z.number().int().positive().optional(),
    height: zod_1.z.number().int().positive().optional(),
});
//# sourceMappingURL=asset.js.map